import CharacteristicBox from './CharacteristicBox.vue'

export default CharacteristicBox
